import React from 'react';
import { PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { MsalProvider, useMsalAuthentication, useIsAuthenticated } from '@azure/msal-react';
import { msalConfig, loginRequest } from 'src/auth/authConfig';
import { HttpClientProvider } from 'src/utils/httpClient';
import AuthenticationStatusPage from 'src/auth/AuthenticationStatusPage';
import { Typography } from '@material-ui/core';
import AuthLayout from 'src/auth/AuthLayout';
import useAccessToken from 'src/auth/useAccessToken';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import UserDataProvider from 'src/auth/UserDataProvider';
import { SET_ACCESS_TOKEN } from 'src/actions/authActions';

const msalInstance = new PublicClientApplication(msalConfig);

const IsAuthenticated = ({ children }) => {
    const { login, error } = useMsalAuthentication(InteractionType.Silent, loginRequest);
    const isAuthenticated = useIsAuthenticated();
    const requestedAccessToken = useAccessToken(loginRequest.scopes);
    const dispatch = useDispatch();
    const { accessToken } = useSelector((state) => state.auth);

    React.useEffect(() => {
        if (error) {
            login(InteractionType.Redirect, loginRequest);
        }
    }, [error, login]);

    React.useEffect(() => {
        if (requestedAccessToken) {
            dispatch({ type: SET_ACCESS_TOKEN, data: requestedAccessToken });
        }
    }, [requestedAccessToken, dispatch]);

    if (isAuthenticated && accessToken) {
        return (
            <HttpClientProvider>
                {children}
            </HttpClientProvider>
        );
    }

    return (
        <AuthenticationStatusPage>
            <Typography variant="h5">Logging in</Typography>
        </AuthenticationStatusPage>
    );
};

IsAuthenticated.propTypes = {
    children: PropTypes.any
};

const MsalAuthProvider = ({ children }) => {
    return (
        <AuthLayout>
            <MsalProvider instance={msalInstance}>
                <IsAuthenticated>
                    <UserDataProvider />
                    {children}
                </IsAuthenticated>
            </MsalProvider>
        </AuthLayout>
    );
};

MsalAuthProvider.propTypes = {
    children: PropTypes.any
};

export default MsalAuthProvider;